import { lazy, type ComponentType } from "react";

function page<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  let promise: Promise<{ default: T }> | undefined;
  const preload = () => promise ??= load();
  return { Component: lazy(preload), preload };
}

// One loader per public page, shared by routing and pre-hydration loading.
export const publicPages = {
  "/": page(() => import("./pages/Landing")),
  "/pricing": page(() => import("./pages/Pricing")),
  "/faq": page(() => import("./pages/PublicFAQ")),
  "/blog": page(() => import("./pages/Blog")),
  "/blog/:slug": page(() => import("./pages/BlogPost")),
  "/privacy": page(() => import("./pages/PrivacyPolicy")),
  "/terms": page(() => import("./pages/TermsOfService")),
  "/contact": page(() => import("./pages/ContactUs")),
  "/schedule-a-call": page(() => import("./pages/ScheduleCall")),
  "/lead-form": page(() => import("./pages/LeadForm")),
  "/staff-care-kit": page(() => import("./pages/StaffCareKit")),
  "/sms-consent": page(() => import("./pages/SMSConsent")),
  "/schools": page(() => import("./pages/SchoolsLanding")),
  "/hr": page(() => import("./pages/HRLanding")),
  "/agencies": page(() => import("./pages/AgenciesLanding")),
  "/construction": page(() => import("./pages/ConstructionLanding")),
  "/business": page(() => import("./pages/BusinessLanding")),
  "/coaches": page(() => import("./pages/CoachesLanding")),
};

export async function preloadPublicPage(path: string) {
  const key = path.startsWith("/blog/") ? "/blog/:slug" : path;
  await publicPages[key as keyof typeof publicPages]?.preload();
}
